/**
 * Public ↔ internal job ids.
 *
 * Jobg8 is a silent partner: the agreement forbids naming them anywhere a
 * seeker can see, and Jobg8 support flagged the name on our listings
 * (2026-10-11). Its rows are stored as `job_jobg8_us_<ref>` and that id used
 * to appear verbatim in every job URL. Renaming 3,404 primary keys referenced
 * by ~22 FK columns in D1 is a risky data migration, so the id is aliased at
 * the URL boundary instead:
 *
 *   internal `job_jobg8_us_123`  ⇄  public `job_pf_us_123`
 *
 * Every URL builder runs ids through `publicJobId`; every route that reads a
 * job id from a URL runs it through `internalJobId` (old `job_jobg8_` URLs
 * keep resolving and the detail page 301s them to the public form).
 *
 * Zero imports on purpose — used from client components (job-row) and from
 * the MCP worker's URL builder.
 */

const INTERNAL_PREFIX = "job_jobg8_";
const PUBLIC_PREFIX = "job_pf_";

/** Internal job id → the id that may appear in a URL. */
export function publicJobId(id: string): string {
	return id.startsWith(INTERNAL_PREFIX)
		? PUBLIC_PREFIX + id.slice(INTERNAL_PREFIX.length)
		: id;
}

/** Id read from a URL (public or legacy internal form) → internal job id. */
export function internalJobId(id: string): string {
	return id.startsWith(PUBLIC_PREFIX)
		? INTERNAL_PREFIX + id.slice(PUBLIC_PREFIX.length)
		: id;
}

/** True when a URL carried the legacy internal form that must be redirected. */
export function isLegacyPartnerJobId(id: string): boolean {
	return id.startsWith(INTERNAL_PREFIX);
}
